//
// Software Name: Orange Design System Charts
// SPDX-FileCopyrightText: Copyright (c) 2023 - 2026 Orange SA
// SPDX-License-Identifier: MIT
//
// This software is distributed under the MIT license.
//
export const DEFAULT_OUDS_COLORS_HIGHLIGHT = {
    color: ['var(--ouds-charts-color-highlight)', 'var(--ouds-charts-color-neutral)'],
};
